module.exports = __webpack_public_path__ + "static/media/stairs2.45b80a66.png";